import styled, { css } from "styled-components"
import { Theme } from "styles/theme"

import { PillSize, PillTone } from "."

const toneToPalette: Record<PillTone, keyof Theme["palette"]> = {
  default: "highlight",
  error: "error",
  info: "info",
  success: "success",
  warning: "warning"
}

const sizeToStyles: Record<PillSize, ReturnType<typeof css>> = {
  sm: css`
    font-size: 12px;
    padding: 4px 10px;
  `,
  md: css`
    font-size: 13px;
    padding: 6px 14px;
  `
}

export const PillBase = styled.button<{
  $size: PillSize
  $tone: PillTone
  $clickable: boolean
}>`
  align-items: center;
  background-color: ${({ theme, $tone }: { theme: Theme; $tone: PillTone }) =>
    theme.palette[toneToPalette[$tone]].main};
  border: none;
  border-radius: 999px;
  color: ${({ theme, $tone }: { theme: Theme; $tone: PillTone }) =>
    theme.palette[toneToPalette[$tone]].contrast};
  column-gap: 6px;
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
  display: inline-flex;
  font-family: inherit;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.2;
  outline: none;
  padding: 0;
  transition:
    background-color 120ms ease,
    color 120ms ease;

  ${({ $size }) => sizeToStyles[$size]}

  ${({ $clickable }) =>
    $clickable
      ? css`
          &:hover {
            opacity: 0.9;
          }

          &:focus-visible {
            outline: 2px solid
              ${({ theme }: { theme: Theme }) => theme.palette.info.main};
            outline-offset: 2px;
          }
        `
      : css`
          &:focus {
            outline: none;
          }
        `}
`

export const PillContent = styled.span`
  align-items: center;
  display: inline-flex;
  gap: 6px;
`

export const PillIconSlot = styled.span`
  display: inline-flex;
  line-height: 0;
`
